// src/layouts/Layout.js

import React, { useContext, useEffect } from 'react';
import {
  Route,
  Switch,
  Redirect,
  MemoryRouter,
  useLocation
} from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { CloseButton, Fade } from '../components/common/Toast';

import DashboardLayout from './DashboardLayout';
import ErrorLayout from './ErrorLayout';
import AppContext from './../context/Context';
import loadable from '@loadable/component';

const AuthBasicLayout = loadable(() => import('./AuthBasicLayout'));

// Ahora simulamos también las variantes con "/" al final
const initialEntries = [
  '/authentication/password-reset',
  '/authentication/register',
  '/authentication/loginexam',
  '/guru',              // índice 3
  '/guru/',             // índice 4
  '/guru/login',        // índice 5
  '/guru/login/',       // índice 6
  '/guru/register',     // índice 7
  '/guru/forgot-password', // índice 8
  '/'                   // índice 9
];

const getInitialIndex = pathname => {
  switch (pathname) {
    case '/authentication/password-reset':
      return 0;
    case '/authentication/register':
      return 1;
    case '/authentication/loginexam':
      return 2;
    case '/guru':
      return 3;
    case '/guru/':
      return 4;
    case '/guru/login':
      return 5;
    case '/guru/login/':
      return 6;
    case '/guru/register':
      return 7;
    case '/guru/forgot-password':
      return 8;
    default:
      return 9;
  }
};

const Layout = () => {
  const { currentuser, setCurrentUser } = useContext(AppContext);
  const location = useLocation();

  useEffect(() => {
    AuthBasicLayout.preload();
  }, []);

  useEffect(() => {
    if (
      currentuser &&
      Date.now() - currentuser.startat > currentuser.jwtExpirationMs
    ) {
      setCurrentUser(null);
    }
  }, [currentuser, setCurrentUser]);

  return (
    <MemoryRouter
      initialEntries={initialEntries}
      initialIndex={getInitialIndex(location.pathname)}
    >
      <Switch>
        {/* 0) Error pages */}
        <Route path="/errors" component={ErrorLayout} />

        {/* 1) Auth routes */}
        <Route path="/authentication" component={AuthBasicLayout} />

        {/* 2) /guru, /guru/, /guru/login, /guru/login/ */}
        <Route
          exact
          path={['/guru', '/guru/', '/guru/login', '/guru/login/']}
          render={props =>
            currentuser === null ? (
              <AuthBasicLayout guru={true} {...props} />
            ) : (
              <DashboardLayout {...props} />
            )
          }
        />

        {/* 3) Other /guru/* */}
        <Route
          path="/guru"
          render={props =>
            currentuser === null ? (
              <AuthBasicLayout guru={true} {...props} />
            ) : (
              <DashboardLayout {...props} />
            )
          }
        />

        {/* 4) Root */}
        <Route
          path="/"
          render={props =>
            currentuser === null ? (
              <Redirect to="/authentication/login" />
            ) : (
              <DashboardLayout {...props} />
            )
          }
        />
      </Switch>

      <ToastContainer
        transition={Fade}
        closeButton={<CloseButton />}
        position={toast.POSITION.BOTTOM_LEFT}
      />
    </MemoryRouter>
  );
};

export default Layout;
